import { Link, useLocation } from 'react-router-dom';
import { Box, Flexbox } from '@hiiretail/synergy-ui';
import styled from 'styled-components';
import React, { Fragment } from 'react';
import { useBreadcrumbsActions } from './context/useBreadcrumbsActions';

const BreadcrumbsWrapper = styled(Box)`
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.0805), 0 0 2px rgba(0, 0, 0, 0.03);
  display: flex;
  min-height: 74px;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: black;
  text-decoration: none;
  &:hover {
    color: #6e33a9;
  }
`;

const StyledStrokeContainer = styled(Flexbox)`
  padding: 0 4.75px;
`;

const StyledStroke = () => (
  <StyledStrokeContainer container item alignItems="center" justifyContent="center">
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75015 0.0857849L6.95726 5.29289C7.34778 5.68342 7.34778 6.31658 6.95726 6.70711L1.75015 11.9142L0.335938 10.5L4.83594 6L0.335938 1.5L1.75015 0.0857849Z"
        fill="#616161"
      />
    </svg>
  </StyledStrokeContainer>
);

const breadcrumbNameMap: { [key: string]: string } = {
  tenants: 'Tenants',
  groups: 'Groups',
  users: 'Users',
  permissions: 'Permissions',
  'identity-providers': 'Identity providers',
  'built-in-roles': 'Built-in roles',
  'custom-roles': 'Custom roles',
  profile: 'Profile',
  'my-tenant': 'My Tenant',
  'external-app': 'External Apps',
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const { actions } = useBreadcrumbsActions();

  const pathNames = location.pathname.split('/').filter((x) => x);

  return (
    <BreadcrumbsWrapper px={6} py={4}>
      <Flexbox
        container
        item
        justifyContent="space-between"
        alignItems="center"
        style={{ width: '100%' }}
      >
        <Flexbox item container gutter={3}>
          <Flexbox item>
            <StyledLink
              to="/"
              onClick={(event) => {
                event.preventDefault();
                window.location.href = window.location.origin;
              }}
            >
              {'Console'}
            </StyledLink>
          </Flexbox>
          <StyledStroke />
          <Flexbox item>
            <StyledLink color="inherit" to="/">
              {'Identity and Access Management'}
            </StyledLink>
          </Flexbox>
          {pathNames.map((name, index) => {
            if (index > 1) {
              return null;
            }
            return (
              <Fragment key={name}>
                <StyledStroke />
                <Flexbox item>
                  <StyledLink to={`/${pathNames.slice(0, index + 1).join('/')}`}>
                    {breadcrumbNameMap[name] || name}
                  </StyledLink>
                </Flexbox>
              </Fragment>
            );
          })}
        </Flexbox>
        <Flexbox item container gutter={4} alignItems="center">
          {actions}
        </Flexbox>
      </Flexbox>
    </BreadcrumbsWrapper>
  );
};
